import api from '@/api'

export default {
  // 空闲教练列表
  getIdleCoach (uuid) {
    return api({
      url: `/squad/${uuid}/leisure`,
      method: 'GET'
    })
  },
  // 空闲领队列表
  getIdleLeader (uuid) {
    return api({
      url: `/squad/${uuid}/leisure/leader`,
      method: 'GET'
    })
  },
  // 获取所有球队
  getAllSquad () {
    return api({
      url: '/squad/helper',
      method: 'GET'
    })
  },
  // 获取球队信息
  getSquadInfo (uuid) {
    return api({
      url: `/squad/squadInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 获取球员位置
  getPlayerOption () {
    return api({
      url: '/player/position/all',
      method: 'GET'
    })
  },
  // 检测身份证号
  checkIdNumber (idNumber, userUuid) {
    return api({
      url: `/user/checkIdNumber/${idNumber}/${userUuid}`,
      method: 'GET',
      params: {
        idNumber,
        userUuid
      }
    })
  },
  // 检测手机号
  checkPhone (Phone, userUuid) {
    return api({
      url: `/user/checkPhone/${Phone}/${userUuid}`,
      method: 'GET',
      params: {
        Phone,
        userUuid
      }
    })
  },
  // 获取用户信息
  getUserInfo () {
    return api({
      url: '/user/userInfo',
      method: 'GET'
    })
  },
  // 查询单位信息
  getCompanyInfo () {
    return api({
      url: '/company/companyInfo',
      method: 'GET'
    })
  },
  // 修改单位信息
  updataCompanyInfo (data) {
    return api({
      url: '/company',
      method: 'PUT',
      data
    })
  },
  // 球队教练领队球员-各自的总数量
  getCountNum () {
    return api({
      url: '/squad/countNum',
      method: 'GET'
    })
  },
  // 获取省市县
  getRegion (cacheAt) {
    return api({
      url: '/region',
      method: 'GET',
      params: { cacheAt }
    })
  },
  // 公共接口-个人设置-(修改个人信息)
  upadtaUserInfo (params) {
    return api({
      url: '/user/teachingPlanStatus',
      method: 'PUT',
      params
    })
  },
  // 修改密码
  changePassword (params) {
    return api({
      url: '/user/changePassword',
      method: 'PUT',
      params
    })
  },
  // 公共接口-个人设置-(修改个人信息)
  phoneSendVCode (phone) {
    return api({
      url: `/phoneSendVCode/bind/${phone}`,
      method: 'POST'
    })
  },
  // 绑定（修改）手机
  bindNewPhone (phone, code) {
    return api({
      url: `/user/bind/${phone}/${code}`,
      method: 'PUT'
    })
  },
  // 获取图片验证码
  getCodeImg (timestamp) {
    return api({
      url: `/phoneSendVCode/${timestamp}`,
      method: 'GET',
      responseType: 'arraybuffer'
    })
  },
  // 发送找回密码用的验证码
  findPasswordCode () {
    return api({
      url: '/phoneSendVCode/findPassword',
      method: 'POST'
    })
  },
  // 忘记密码？重置密码
  findPassword (params) {
    return api({
      url: '/user/findPassword/phone',
      method: 'PUT',
      params
    })
  },
  downfile (url, name = '') {
    const aEle = document.createElement('a')
    document.body.appendChild(aEle)
    aEle.setAttribute('href', url)
    aEle.setAttribute('target', '_blank')
    aEle.setAttribute('download', name)
    aEle.click()
    document.body.removeChild(aEle)
  },
  // 登录时重置密码发送短信
  resetSendVerifyCode () {
    return api({
      url: '/phoneSendVCode/resetSendVerifyCode',
      method: 'GET'
    })
  },
  loginFindPassword (params) {
    return api({
      url: '/updatePassword',
      method: 'POST',
      params
    })
  },

  // 获取配置信息
  getConfigInfo(params) {
    return api({
      url: '/config/system',
      method: 'GET',
      params
    })
  },

  // 创建图形验证码
  createVerifycode(params) {
    const {nonce_str, timestamp } = params;
    return api({
      url: `/integration/club/createVerifyCode/${nonce_str}/${timestamp}`,
      method: 'POST',
    })
  },

  // 发送验证码
  sendPhoneCode(data) {
    return api({
      url: '/phoneSendVCode/registerCode',
      method: 'POST',
      data
    })
  },

  // 获取单位信息（根据所属区域）
  getYouthListByAddress(params) {
    const { provinceCode, cityCode, countyCode } = params;
    return api({
      url: `/integration/club/clubRegisterOrganList/${provinceCode}/${cityCode}/${countyCode}`,
      method: 'GET',
      params
    })
  },

  // 获取单位信息（根据所属区域）
  postRegisFormData(data) {
    return api({
      url: '/integration/club/clubRegister',
      method: 'POST',
      data
    })
  },

  // 获取俱乐部名称
  getClubList(params) {
    return api({
      url: '/integration/club/ClubList',
      method: 'GET',
      params
    })
  },

}
